.closeButton {
  color: var(--tuna-content-secondary);
  z-index: 1;
}
